import loadable from '@loadable/component';
import usePatchHook from '../../customHooks/usePatchHook';
import APIS from '../../constant/Endpoint';
import useGetHook from '../../customHooks/useGetHook';
import { useParams } from 'react-router-dom';
import Spinner from '../../components/Reusable/Spinner';

const EditSmsCampaignComponent = loadable(
  () =>
    import('../../components/SmsCampaign/SmsCampaignUpdate/SmsCampaignUpdate')
);

const EditSmsCampaign = () => {
  const { id } = useParams();
  const { data, isLoading: isDataLoading } = useGetHook({
    url: `${APIS.SMS_CAMPAIGN}${id}/`,
    queryKey: ['sms-campaign', `sms-campaign-${id}`],
    params: {},
  });

  const { mutateAsync, isLoading } = usePatchHook({
    queryKey: ['sms-campaign'],
  });

  const handleEdit = async (values: any, setError: any, isDraft: boolean) => {
    const url = `${APIS.SMS_CAMPAIGN}${id}/`;
    const formData = {
      ...values,
      is_draft: isDraft,
    };
    try {
      mutateAsync({ url, formData, setError });
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <>
      {isDataLoading ? (
        <Spinner />
      ) : (
        <EditSmsCampaignComponent
          handleEdit={handleEdit}
          isLoading={isLoading}
          data={data}
        />
      )}
    </>
  );
};

export default EditSmsCampaign;
